import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    slider: {
      height: '100%',
      padding: '2px 0 1px',
      [theme.fn.largerThan('sm')]: {
        padding: '10px 5px',
      },
    },
  }
})
